import { render, staticRenderFns } from "./securityAlert.vue?vue&type=template&id=2ddf2280&scoped=true&"
import script from "./securityAlert.vue?vue&type=script&lang=js&"
export * from "./securityAlert.vue?vue&type=script&lang=js&"
import style0 from "./securityAlert.vue?vue&type=style&index=0&id=2ddf2280&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf2280",
  null
  
)

export default component.exports